import type { Node } from 'prosemirror-model';

import { expValEquals } from '@confluence/feature-experiments';

import { getHeadingIdForNode } from './headingLinksFromElements';

export const copyLink = async (
	node: Node,
	getHeadingLinkPath: () => string | null,
): Promise<boolean> => {
	try {
		const headingId = getHeadingIdForNode(node);
		if (!headingId) {
			return false;
		}

		let url: URL;
		if (expValEquals('confluence_frontend_editor_heading_links_view_page', 'cohort', 'variant1')) {
			const path = getHeadingLinkPath();

			if (!path) {
				return false;
			}

			url = new URL(location.origin + path);
		} else {
			url = new URL(location.href);
		}

		url.hash = encodeURIComponent(headingId);
		const href = url.toString();

		if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
			await navigator.clipboard.writeText(href);
			return true;
		}

		return false;
	} catch {
		return false;
	}
};
